import React from 'react';
import ReactDOM from 'react-dom';
import { Tabs, Collapse } from 'antd';
import { addCtnCommonAttribute, sgiCtnBaseFun } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory'
const TabPane = Tabs.TabPane;
const Panel = Collapse.Panel;
import { SgiEventHandler } from './SgiEventHandler';
import { uuid } from "rt-sd-common/sgiCommon/sgiCommon";
import { getConstByKey } from './sgiBaseComp/SgiCommon';
// import { addCollapseCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun'

class SgiCollapse extends React.Component {

	//这个暂时不好用 以后在处理
	static defaultProps = {
	};  // 注意这里有分号
	static propTypes = {
	};

	constructor(props) {
		super(props);
		this.state = {
			itemPanelType: "cos",//区分是tab还是折叠面板的 普通面板整合tabpane和折叠panel
			collapseProps: { style: { height: "100%", width: "100%" } },//form属性
			collapseItems: [], //form下控件数组
			functions: {},
			loading: false,
			activeKey: undefined
		};
	}

    /**
     * 根据描述创建form
     * @param {父组件} parentModule
     * @param {描述} moduleDesc
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
	collapse_mk(parentModule, moduleDesc, objFct, type) {
		//获取需要展示的数据信息
		if (!moduleDesc) {
			return;
		}
		this.state.collapseProps = { style: {} }; //form属性
		this.state.collapseItems = []; //form下控件数组

		//转换基础属性
		this.AddAttribute(moduleDesc, this.state.collapseProps, this);
		//转换form公共属性
		addCtnCommonAttribute(this, moduleDesc, this.state.collapseProps);
		//设置布局
		//this.setFormCtlLayout(moduleDesc, formProps);
		//绑定事件
		this.bindEvent(parentModule, moduleDesc, this.state.collapseProps, this.state.functions, type);
		//组装form表单下的控件信息
		if (type !== "dnd") this.fitTabsItems(moduleDesc, this.state.collapseItems, objFct, type);
		//添加拖拽布局信息 根据type类型
		// addCollapseCtlDndInfo(this, this.state.collapseItems, this.state.collapseProps, type);
		let addCollapseCtlDndInfo = this.props.addCollapseCtlDndInfo;//显示/开发分离，这部分拖拽开发功能使用props传入
		if (addCollapseCtlDndInfo && typeof addCollapseCtlDndInfo === "function") {
			addCollapseCtlDndInfo(this, this.state.collapseItems, this.state.collapseProps, this.props.type);
		}
	}

    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} formProps
     */
	bindEvent(parentModule, moduleDesc, collapseProps, functions, type) {
		//拖拽模式 不生成事件
		tool.sgiLogger.log("parentModule", parentModule);
		var expandLsn = moduleDesc.epdLsn;// 面板的展开监听器
		// var collapseLsn = wvJson.clpLsn;// 面板的折叠监听器
		if (expandLsn && type != 'dnd') {
			var $expandLsn = new Function("module", "objFct", "key", expandLsn);
			functions.expandLsn = $expandLsn;
		}
		collapseProps.onChange = SgiEventHandler.expd.bind(this);
		// if (collapseLsn) {
		//     var $expandLsn = new Function("objFct", "ctn", collapseLsn);
		//     functions.collapseLsn = $collapseLsn;
		//     formProps.onChange = SgiEventHandler.clp.bind(this);
		// }
	}


    /**
     * 根据描述组装子对象
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
	fitTabsItems = function (moduleDesc, tabsItems, objFct, type) {
		var me = this;

		let cldSet = moduleDesc.cldSet;
		if (cldSet && cldSet.length && cldSet.length > 0) {
			let cosPane;
			cldSet.forEach((item, index) => {
				let { te, isDis } = item;
				let cId = getConstByKey(this, item.cId);
				cosPane = { forceRender: true }; //默认全部加载
				if (!cId) {
					cId = uuid(8);
					item.cId = cId;
				}
				if (te) cosPane.header = te;
				if (cId) cosPane.key = cId;
				if (isDis) cosPane.disabled = isDis;
				tabsItems.push(<Panel {...cosPane}>{convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem })}</Panel>);
			});
		}
	}

	setActiveItem = (key) => {
		this.setState({ activeKey: key });
	}
    /**
     * 获取当前激活面板的组件标识
     * @return {[type]} [description]
     */
	getActiveItem = () => {
		return this.state.activeKey;
	}
	refresh = () => {
		this.loaded = false;
		this.setState({ loading: false });
	}



	//渲染并返回一个虚拟DOM
	render = function () {
		if (!this.loaded || this.props.type == 'dnd') {
			let { parentModule, moduleDesc, objFct, type } = this.props;
			//组装属性
			this.collapse_mk(parentModule, moduleDesc, objFct, type);
			this.loaded = true;
		}

		// 通用渲染前处理，添加自定义样式等
		this.renderBeforeReturn(this.state.collapseProps);

		return (
			<Collapse {...this.state.collapseProps} activeKey={this.state.activeKey}>
				{this.state.collapseItems}
			</Collapse>
		)
	}

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
	AddAttribute = function (moduleDesc, tabsProps, collp) {
		//初始化激活的面板
		let atvTab = getConstByKey(this, moduleDesc.atvTab);
		if (atvTab) {
			tabsProps.defaultActiveKey = atvTab;
			if (!collp.state.activeKey) {
				collp.state.activeKey = atvTab;
			}
		}

		tabsProps.accordion = true;//先默认这个 以后再去实现其他的属性
	}
}
//给类添加公共方法
Object.assign(SgiCollapse.prototype, sgiCtnBaseFun);

export { SgiCollapse };
export default SgiCollapse;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiCollapse.js